var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8.958,
    transform: "rotate(180)",
    viewBox: "0 0 8 8.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M240.324,544.958a.617.617,0,0,0,.491-.216.861.861,0,0,0,.185-.58V536.8a.864.864,0,0,0-.185-.581.619.619,0,0,0-.491-.215.851.851,0,0,0-.306.056,2.1,2.1,0,0,0-.318.156l-6.091,3.528a1.756,1.756,0,0,0-.473.354.617.617,0,0,0,0,.773,1.8,1.8,0,0,0,.473.351l6.091,3.528a2.1,2.1,0,0,0,.318.156A.851.851,0,0,0,240.324,544.958Z",
    transform: "translate(-233 -536)",
    fill: "#7e84a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/Triangle.89e518aa161d099b2b75fc41ca941a0a.svg";
export { ForwardRef as ReactComponent };